"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDataSearch = void 0;
const QueryFieldKey_1 = __importDefault(require("@opsbase/lib-data-queryfield/QueryFieldKey"));
const ViewFieldKey_1 = __importDefault(require("@opsbase/lib-data-viewfield/ViewFieldKey"));
const useAssets_1 = require("@opsbase/react-gql-hooks/asset/useAssets");
const useIndustries_1 = require("@opsbase/react-gql-hooks/industry/useIndustries");
const useOpDefinitions_1 = require("@opsbase/react-gql-hooks/opdefinition/useOpDefinitions");
const useOrgs_1 = require("@opsbase/react-gql-hooks/organisation/useOrgs");
const usePlaces_1 = require("@opsbase/react-gql-hooks/place/usePlaces");
const usePositons_1 = require("@opsbase/react-gql-hooks/position/usePositons");
const useStaff_1 = require("@opsbase/react-gql-hooks/staff/useStaff");
const useTeams_1 = require("@opsbase/react-gql-hooks/team/useTeams");
function useDataSearch(key, variables = {}, options = {
    fields: 'id, title',
}, forceSkip = false) {
    const { loading: lAsset, data: dAsset } = (0, useAssets_1.useAssetsCollection)(Object.assign(Object.assign({ variables }, options), { skip: forceSkip || key !== QueryFieldKey_1.default.ASSET }));
    const { loading: lOpDefinition, data: dOpDefinition } = (0, useOpDefinitions_1.useOpDefinitionsCollection)(Object.assign(Object.assign({ variables }, options), { fields: 'id, title', skip: forceSkip || key !== QueryFieldKey_1.default.OPDEFINITION }));
    const { loading: lOrganisation, data: dOrganisation } = (0, useOrgs_1.useOrgsCollection)(Object.assign(Object.assign({ variables }, options), { fields: 'id, title', skip: forceSkip || key !== QueryFieldKey_1.default.ORGANISATION }));
    const { loading: lPosition, data: dPosition } = (0, usePositons_1.usePositionsCollection)(Object.assign(Object.assign({ variables }, options), { skip: forceSkip || key !== QueryFieldKey_1.default.POSITION }));
    const { loading: lPlace, data: dPlace } = (0, usePlaces_1.usePlacesCollection)(Object.assign(Object.assign({ variables }, options), { sortBy: [ViewFieldKey_1.default.PLACE], skip: forceSkip || key !== QueryFieldKey_1.default.PLACE }));
    const { loading: lStaff, data: dStaff } = (0, useStaff_1.useStaffCollection)(Object.assign(Object.assign({ variables }, options), { skip: forceSkip || (key !== QueryFieldKey_1.default.STAFF && key !== QueryFieldKey_1.default.ISSUE_CREATEDBY) }));
    const { loading: lTeam, data: dTeam } = (0, useTeams_1.useTeamsCollection)(Object.assign(Object.assign({ variables }, options), { skip: forceSkip || key !== QueryFieldKey_1.default.TEAM }));
    const { loading: lIndustry, data: dIndustry } = (0, useIndustries_1.useIndustriesCollection)(Object.assign(Object.assign({ variables }, options), { skip: forceSkip || key !== QueryFieldKey_1.default.INDUSTRY }));
    switch (key) {
        case QueryFieldKey_1.default.ASSET:
            return { loading: lAsset, data: dAsset };
        case QueryFieldKey_1.default.OPDEFINITION:
            return { loading: lOpDefinition, data: dOpDefinition };
        case QueryFieldKey_1.default.ORGANISATION:
            return { loading: lOrganisation, data: dOrganisation };
        case QueryFieldKey_1.default.POSITION:
            return { loading: lPosition, data: dPosition };
        case QueryFieldKey_1.default.PLACE:
            return { loading: lPlace, data: dPlace };
        case QueryFieldKey_1.default.STAFF:
        case QueryFieldKey_1.default.ISSUE_CREATEDBY:
            return { loading: lStaff, data: dStaff };
        case QueryFieldKey_1.default.TEAM:
            return { loading: lTeam, data: dTeam };
        case QueryFieldKey_1.default.INDUSTRY:
            return { loading: lIndustry, data: dIndustry };
    }
    return { loading: false, data: undefined };
}
exports.useDataSearch = useDataSearch;
exports.default = useDataSearch;
